import { toastApi } from '@/shared/utils/toast';

/** "2026-01-05" → "2026. 01. 05" (M-19 · M-20 행 날짜 표기) */
export const formatSpacedDate = (date?: string | null) => {
  if (!date || date.length < 10) return null;
  return `${date.slice(0, 4)}. ${date.slice(5, 7)}. ${date.slice(8, 10)}`;
};

/** 클립보드 복사 + 스낵바. 헤더 [전화] · 주소 모달 [주소 복사]가 같은 규칙을 쓴다 (M-21) */
export const copyWithToast = async (
  text: string,
  success: string,
  failure: string,
) => {
  try {
    await navigator.clipboard.writeText(text);
    toastApi.info(success);
  } catch {
    toastApi.error(failure);
  }
};
